import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "./slices/auth";
import broadcastReducer from "./slices/broadcast";
import broadcastListReducer from "./slices/broadcastList";
import callHistoryReducer from "./slices/callHistory";
import categoryReducer from "./slices/category";
import channelReducer from "./slices/channel";
import conversationReducer from "./slices/conversation";
import customerReducer from "./slices/customer";
import customFieldsReducer from "./slices/customField";
import dailyMessageReducer from "./slices/dailyMessage";
import dashboardReducer from "./slices/dashboard";
import invoiceReducer from "./slices/invoice";
import layoutReducer from "./slices/layout";
import mediaContentReducer from "./slices/mediaContent";
import messageReducer from "./slices/message";
import messageTemplateReducer from "./slices/messageTemplate";
import noteReducer from "./slices/note";
import noticeReducer from "./slices/notice";
import notificationReducer from "./slices/notification";
import addressReducer from "./slices/numbers";
import paymentReducer from "./slices/payment";
import subscriptionsReducer from "./slices/subscriptions";
import uploadReducer from "./slices/upload";
import userReducer from "./slices/user";
import voiceSettingReducer from "./slices/voiceSetting";
import workspaceReducer from "./slices/workspace";
import workspaceSettingReducer from "./slices/workspaceSetting";
import workspaceUserReducer from "./slices/workspaceUser";

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  notice: noticeReducer,
  layout: layoutReducer,
  workspace: workspaceReducer,
  workspaceSetting: workspaceSettingReducer,
  workspaceUser: workspaceUserReducer,
  subscriptions: subscriptionsReducer,
  upload: uploadReducer,
  customer: customerReducer,
  broadcastList: broadcastListReducer,
  messageTemplate: messageTemplateReducer,
  customFields: customFieldsReducer,
  conversation: conversationReducer,
  message: messageReducer,
  broadcast: broadcastReducer,
  address: addressReducer,
  mediaContent: mediaContentReducer,
  note: noteReducer,
  invoice: invoiceReducer,
  payment: paymentReducer,
  notification: notificationReducer,
  channel: channelReducer,
  category: categoryReducer,
  dashboard: dashboardReducer,
  dailyMessage: dailyMessageReducer,
  voiceSetting: voiceSettingReducer,
  callHistory: callHistoryReducer,
});
